<section class="bk-panel rg" aria-labelledby="rg-age-title">
  <header class="rg__head">
    <h2 class="bk-eyebrow" id="rg-age-title">Age</h2>
    @if (hasData) {
      <span class="rg__note">Of {{ formatCount(total) }} recipients</span>
    }
  </header>

  @if (hasData) {
    <div class="rg__canvas" [style.height.px]="height" aria-hidden="true">
      <canvas baseChart [type]="'bar'" [data]="chartData" [options]="chartOptions"></canvas>
    </div>

    <dl class="rg__list">
      @for (row of rows; track row.label) {
        <div class="rg__item">
          <dt>{{ row.label }}</dt>
          <dd>
            <span class="rg__count">{{ row.countLabel }}</span>
            <span class="rg__share">{{ row.shareLabel }}</span>
          </dd>
        </div>
      }
    </dl>
  } @else {
    <p class="rg__empty">No age data for these recipients yet.</p>
  }
</section>
